import { MafTab } from '../../MafTypes';

export type MafTabWithTemplate = Omit<MafTab, 'tab_template'> &
  Required<Pick<MafTab, 'tab_template'>>;

export const mafTabHasTemplate = (tab: MafTab): tab is MafTabWithTemplate =>
  tab.tab_template != null;
